import $ from 'jquery';

export default {
    name: "sidebar",
    components: {},
    props: [],
    data() {
        return {
            articles: false,
            autorisation: false,
        };
    },

    computed: {
        userCredentials() {
            return this.$store.getters["authInfo"];
        },
        activeRole() {
            return this.$store.getters["activeRole"];
        },
    },

    mounted() {
        this.checkRole();
    },

    methods: {
        toggleClassChevron: function (htmlclass) {
            let className = $("." + htmlclass + " .chevron i").attr("class");

            if (className === "fa fa-chevron-down ico-small") {
                $("." + htmlclass + " .chevron i").removeClass(
                    "fa-chevron-down ico-small"
                );
                $("." + htmlclass + " .chevron i").addClass("fa-chevron-up ico-small");
            } else {
                $("." + htmlclass + " .chevron i").removeClass(
                    "fa-chevron-up ico-small"
                );
                $("." + htmlclass + " .chevron i").addClass(
                    "fa-chevron-down ico-small"
                );
            }
        },


        checkRole() {
            this.userCredentials.user.roles.forEach((element) => {
                if (
                    element.nom == "ROLE_ADMINISTRATEUR" ||
                    element.nom == "ROLE_PHARMACIEN"
                ) {
                    this.autorisation = true;
                }
            });
            return this.autorisation;
        },

        closeSidebar() {
            const sidebar = $('#sdbr');
            if (sidebar.hasClass('shw-sdbar')) {
                sidebar.removeClass('shw-sdbar');
                // Trigger toggleSidebar in navbar to update the icon state
                this.$root.$emit('closeSidebar');
            }
        },

        onSidebarItemClick(e) {
            // Close sidebar when any menu <li> is clicked (mobile behavior),
            // but don't close when the click is only meant to expand/collapse a submenu.
            const $target = $(e.target);
            if ($target.closest('a[data-toggle="collapse"]').length) return;

            // Only react to clicks within an <li> inside the menu
            if (!$target.closest('li').length) return;

            this.closeSidebar();
        },
    },
};


